import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=7df8eb2c&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df8eb2c')) {
      api.createRecord('7df8eb2c', component.options)
    } else {
      api.reload('7df8eb2c', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=7df8eb2c&", function () {
      api.rerender('7df8eb2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2COH0VANCSZxP/JS/pricehelp.vue"
export default component.exports